import React, { useState, useEffect } from 'react'
import Header from "components/Headers/Header.js";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import axios from 'axios'
import { Card, CardHeader, CardBody, Container, Row, Col, Spinner, Button, Alert, FormGroup, Form, Input, InputGroup} from "reactstrap";
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'
import ReactFlagsSelect from "react-flags-select";
import {Link} from 'react-router-dom'

function InsuranceAccount() {
    
    const [loading, setLoading] = useState(true)
    const [error, setError]=useState(false)
    const [message, setMessage]=useState(true)

    const [insurancecompanyoptions, setInsurancecompanyoptions]=useState([])
    const [insurancecompany, setInsurancecompany]=useState("")

    const [operatorname, setOperatorname]=useState('')
    const [operatorsurname, setOperatorsurname]=useState('')
    const [country, setCountry]=useState("")
    const [city, setCity]=useState('')
    const [adress, setAdress]=useState('')
    const [vatnumber, setVatnumber]=useState('')
    const [sdi, setSdi]=useState('')    
    const [email, setEmail]=useState('')
    const [phone, setPhone]=useState('')   

    const [loadingsubmit, setLoadingsubmit] = useState(true)
    
    const [modal, setModal] = useState(false);
    const toggleModal = () => setModal(!modal);

    const token = useSelector((state) => state.userLogin.userInfo.token);

    ////////////
    const { t, i18n } = useTranslation();  

    useEffect(() => {
        const storedLanguage = localStorage.getItem('selectedLanguageAFS');
        if (storedLanguage) {
        i18n.changeLanguage(storedLanguage);
        }
    }, [i18n]);
    ////////////

    useEffect(() => {

        const fetchData = async () => {

            try {
                const config = {
                    headers: {
                        'Content-type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                }
                
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/insurance/insurance-operator-profile/`, config);
                
                if (response.status===204) {
                    
                } else {
                    
                    setInsurancecompany(response.data.insurance_company_name)
                    setOperatorname(response.data.operator_name)
                    setOperatorsurname(response.data.operator_surname)
                    setCity(response.data.city)
                    setCountry(response.data.country)
                    setAdress(response.data.adress)
                    setVatnumber(response.data.vat_number)
                    setSdi(response.data.sdi_recipient_code)
                    setEmail(response.data.company_email)
                    setPhone(response.data.phone)

                }

            } catch (error) {
                
                console.log(error)

            } finally {
            }
        };

        fetchData(); 
    }, [token]);

    useEffect(() => {

        const fetchData = async () => {

            try {
                const config = {
                    headers: {
                        'Content-type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                }
                
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/insurance/insurance-company-list/`, config);
                
                setInsurancecompanyoptions(response.data)

                setInsurancecompany(response.data[0].id)

            } catch (error) {
                
                console.log(error)

            } finally {
                setLoading(false)
            }
        };

        fetchData(); 
    }, [token]);

    const ExistInsuranceAccount = async () => {

        try {

            const config = {

                headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${token}`
                }
                
            }

            const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/insurance/check-operator-insurance-exist/`, config);
            
            return response.data.message;

        } catch (error) {
            console.error("Error fetching farmer ID:", error);
            throw error;
        }
    };

    const submit  = async (e) => {
        
        setLoadingsubmit(false)

        if (insurancecompany==='') {
            setMessage(t('The insurance company is empty'))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmit(true);
            return;
        } 

        if (operatorname==='') {
            setMessage(t('The first name is empty'))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmit(true);
            return;
        }

        if (operatorsurname==='') {
            setMessage(t('The last name is empty'))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmit(true);
            return;
        }

        if (country==='') {
            setMessage(t('The country is empty'))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmit(true);
            return;
        }

        if (city==='') {
            setMessage(t('The city is empty'))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmit(true);
            return;
        }

        if (adress==='') {
            setMessage(t('The adress is empty'))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmit(true);
            return;
        }

        if (vatnumber==='') {
            setMessage(t('The VAT number is empty'))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmit(true);
            return;
        }

        if (sdi==='') {
            setMessage(t('The SDI is empty'))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmit(true);
            return;
        }

        if (email==='') {
            setMessage(t('The company email is empty'))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmit(true);
            return;
        }

        if (phone==='') {
            setMessage(t('The phone number is empty'))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmit(true);
            return;
        }


        const exist = await ExistInsuranceAccount()

        try {

            if (exist==="False") {
                
                const config = {
                    headers: {
                        'Content-type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                };   

                const payload = {
                    insurance_company_name: insurancecompany,
                    operator_name: operatorname,
                    operator_surname: operatorsurname,
                    country: country,
                    city: city,
                    adress: adress,
                    vat_number: vatnumber,
                    sdi_recipient_code: sdi,
                    company_email: email,
                    phone: phone
                }

                await axios.post(`${process.env.REACT_APP_BACKEND_API}/insurance/create-operator-insurance-profile/`, payload, config);    

            } else {

                const config = {
                    headers: {
                        'Content-type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                };   

                const payload = {
                    insurance_company_name: insurancecompany,
                    operator_name: operatorname,
                    operator_surname: operatorsurname,
                    country: country,
                    city: city,
                    adress: adress,
                    vat_number: vatnumber,
                    sdi_recipient_code: sdi,
                    company_email: email,
                    phone: phone
                }

                await axios.put(`${process.env.REACT_APP_BACKEND_API}/insurance/edit-operator-insurance-profile/`, payload, config);  

            }            

        } catch (error) {
            setMessage(t("Some problems occured, please retry and if the problem persists please send an email to info@automaticfarmsolution.com"))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmit(true)
            return;
        } finally {
            setLoadingsubmit(true)
            toggleModal()
        }
    }
    
    return (
        <div>
            <Header/>
            {loading ? (
                <Container className="mt--15" fluid>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                            <Spinner>
                                {t('Loading')}
                            </Spinner>
                        </Col>
                    </Row>
                </Container>
            ):(
                <Container className="mt--15" fluid>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                            <Card>
                                <CardHeader>
                                    <h3>{t('Insurance Account Setting')}</h3>
                                </CardHeader>
                                <CardBody>
                                    <p>{t('After set your insurance account, all the farmer user could see your activity available in order to link the device directly to you')}</p>
                                    <p>{t('When a farmer link its devices with you, you can access to those data, and if happen a damiging event, you will be notified')}</p>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="text-center mt-5">
                            <Card>
                                <CardBody>
                                    <Form role="form">
                                        <FormGroup>
                                            <p>{t('Insurance Company')}</p>
                                            <Input 
                                                type="select" 
                                                onChange={(e) => setInsurancecompany(e.target.value)} 
                                                value={insurancecompany}>
                                                    {insurancecompanyoptions.map((company, index) => (
                                                        <option key={index} value={company.id}>
                                                            {company.name}
                                                        </option>
                                                    ))}
                                            </Input>
                                        </FormGroup>
                                        <FormGroup> 
                                            <p>{t("Operator name")}</p>
                                            <InputGroup className="input-group-alternative mb-3">
                                                <Input 
                                                    placeholder={t("Operator name")}
                                                    as="text"
                                                    controlid='operatorname'
                                                    value={operatorname} 
                                                    onChange={(e) => setOperatorname(e.target.value)} />
                                            </InputGroup>
                                        </FormGroup>
                                        <FormGroup>
                                            <p>{t("Operator Surname")}</p>
                                            <InputGroup className="input-group-alternative mb-3">
                                                <Input 
                                                    placeholder={t("Operator Surname")}
                                                    as="text"
                                                    controlid='operatorsurname'
                                                    value={operatorsurname} 
                                                    onChange={(e) => setOperatorsurname(e.target.value)} />
                                            </InputGroup>
                                        </FormGroup>
                                        <p>{t('Country')}</p>
                                        <ReactFlagsSelect
                                            onSelect={(country) => {setCountry(country)}}
                                            placeholder={t('Country')}
                                            fullWidth={true}
                                            selected={country}
                                            searchable={true}
                                        />
                                        <br></br>
                                        <FormGroup>
                                            <p>{t("City")}</p>
                                            <InputGroup className="input-group-alternative mb-3">
                                                <Input 
                                                    placeholder={t("City")}
                                                    as="text"
                                                    controlid='city'
                                                    value={city} 
                                                    onChange={(e) => setCity(e.target.value)} />
                                            </InputGroup>
                                        </FormGroup>                                      
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="text-center mt-5">
                            <Card>
                                <CardBody>
                                    <Form role="form">
                                        <FormGroup>
                                            <p>{t("Adress")}</p>
                                            <InputGroup className="input-group-alternative mb-3">
                                                <Input 
                                                    placeholder={t("Adress")}
                                                    as="text"
                                                    controlid='Adress'
                                                    value={adress} 
                                                    onChange={(e) => setAdress(e.target.value)} />
                                            </InputGroup>
                                        </FormGroup>
                                        <FormGroup>
                                            <p>{t("VAT Number")}</p>
                                            <InputGroup className="input-group-alternative mb-3">
                                                <Input 
                                                    placeholder={t("VAT Number")}
                                                    as="text"
                                                    controlid='vat'
                                                    value={vatnumber} 
                                                    onChange={(e) => setVatnumber(e.target.value)} />
                                            </InputGroup>
                                        </FormGroup>
                                        <br></br>
                                        <p>{t("Phone")}</p>
                                        <PhoneInput
                                            placeholder="Phone Number"
                                            value={phone}
                                            onChange={(phone) => setPhone(phone)}/>
                                         <br></br>
                                        <FormGroup>
                                            <p>{t("SDI Recipient Code")}</p>
                                            <InputGroup className="input-group-alternative mb-3">
                                            <Input 
                                                placeholder={t("SDI Recipient Code")}
                                                type="text"
                                                controlid='sdi'
                                                value={sdi} 
                                                onChange={(e) => setSdi(e.target.value)} />
                                            </InputGroup>
                                        </FormGroup>
                                        <FormGroup>
                                            <p>{t("Company Email")}</p>
                                            <InputGroup className="input-group-alternative mb-3">
                                            <Input 
                                                placeholder={t("Company Email")}
                                                type="email"
                                                controlid='email'
                                                value={email} 
                                                onChange={(e) => setEmail(e.target.value)} />
                                            </InputGroup>
                                        </FormGroup>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                            <Card>
                                <CardHeader>
                                    <h3>{t("Account Setting")} </h3>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                            {error && <Alert  color="danger" fade={false}>{message}</Alert >}
                                        </Col>     
                                        <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                                            {loadingsubmit ? (
                                                    <>
                                                        <Button className="my-4" color="success" type="button" onClick={submit}>
                                                            {t("Save your setting")} 
                                                        </Button>
                                                    </>
                                                ):(
                                                    <>
                                                        <Button color="success" disabled>
                                                            <Spinner size="sm">
                                                                {t("Saving your setting...")}
                                                            </Spinner>
                                                            <span>
                                                                {' '}{t("Saving your setting...")}
                                                            </span>
                                                        </Button>
                                                    </>
                                            )}
                                        </Col>    
                                        <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                                            <Link to="/">
                                                <Button color='primary'>
                                                    {t("Go back")} <i className="fas fa-rotate-left"></i>
                                                </Button>
                                            </Link>
                                        </Col>                           
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Modal isOpen={modal} toggle={toggleModal}>
                        <ModalHeader toggle={toggleModal}>{t('Your insurance account is well setted')}</ModalHeader>
                        <ModalBody>
                            <p>{t('A email has been sent to your email inbox.') }</p>
                            <p>{t('Now the farmers can link their devices to your account') }</p>
                        </ModalBody>
                    </Modal>
                </Container>
            )}
        </div>
    )
}

export default InsuranceAccount
